var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15,12.5c0,1.657-1.343,3-3,3s-3-1.343-3-3,1.343-3,3-3,3,1.343,3,3ZM13,1c-.552-.552-1.448-.552-2,0l-2,2c-.552.552-.552,1.448,0,2l2,2c.552.552,1.448.552,2,0l2-2c.552-.552.552-1.448,0-2l-2-2Zm.5,16h-3c-.828,0-1.5.672-1.5,1.5v3c0,.828.672,1.5,1.5,1.5h3c.828,0,1.5-.672,1.5-1.5v-3c0-.828-.672-1.5-1.5-1.5Zm7-15h-1c-.829,0-1.5.671-1.5,1.5s.671,1.5,1.5,1.5h1c.276,0,.5.224.5.5v5c0,.276-.224.5-.5.5h-.499v-.951c0-.69-.835-1.036-1.323-.548l-2.451,2.451c-.303.303-.303.793,0,1.096l2.451,2.451c.488.488,1.323.142,1.323-.548v-.951h.499c1.93,0,3.5-1.57,3.5-3.5v-5c0-1.93-1.57-3.5-3.5-3.5Zm-15.177,15.501c-.488-.488-1.323-.142-1.323.548v.951h-.5c-.276,0-.5-.225-.5-.5v-4c0-.275.224-.5.5-.5h2c.829,0,1.5-.672,1.5-1.5s-.671-1.5-1.5-1.5h-2c-1.93,0-3.5,1.57-3.5,3.5v4c0,1.93,1.57,3.5,3.5,3.5h.5v.951c0,.69.835,1.036,1.323.548l2.451-2.451c.303-.303.303-.793,0-1.096l-2.451-2.451Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowIcon);
export default __webpack_public_path__ + "static/media/workflow-icon.12585063217a5dca6e37c956fdab3ed1.svg";
export { ForwardRef as ReactComponent };